import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdAdd } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import PosShippingForm from '../components/PosShippingForm'
import { IconContext } from 'react-icons/lib'
import PosPromoTable from './PosPromoTable'
import PosSMSAlertTable from './PosSMSAlertForm'

class PosSMSAlertForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      isGlobal: true,
      mobile: '',
      report_type: '',
      store_id: '',
    }
  }

  componentDidMount() {
    if (this.props.data.isEdit) {
      let mobile = this.props.data.selectedId
      let report_type = this.props.data.selectedData
      this.setState({
        mobile: mobile,
        report_type: report_type,
        isEdit: true,
      })
    }
    this.setState({
      store_id: this.props.data.store_id,
    })
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    let { name, value } = e.target

    this.setState({
      [name]: value,
    })
  }

  mobileHandler = e => {
    const re = /^[0-9\b]+$/

    // if value is not blank, then test the regex

    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ mobile: e.target.value })
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.create(user, comp, url)
      } else {
        this.update(user, comp, url)
      }
    } else {
      this.add(user, comp, url)
    }
  }

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      mobile: this.state.mobile,
      report_type: this.state.report_type,
      store_id: this.state.store_id,
      added_by: user.email,
    }

    axios
      .post(url + ':3001/v1/store/smsalert/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'SMS Alert added successfully.', 'success', false)
      })
      .catch(error => {
        if (error == 'Bad Request') {
          alert('Duplicate SMS Alert')
        } else {
          alert(error)
        }
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>SMS Alert {this.state.isGlobal ? 'Details' : 'List'}</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>SMS (eg. 65xxxxxxxx)</Label>
                <Input
                  type="text"
                  pattern="[0-9]*"
                  name="mobile"
                  //maxLength="8"
                  value={this.state.mobile}
                  onChange={this.mobileHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Report Type</Label>
                <Input type="select" name="report_type" value={this.state.report_type} onChange={this.changeHandler} required>
                  <option></option>
                  <option value="Item Sale">Item Sale</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export default PosSMSAlertForm
